'use strict';
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector('#tree');
function createTree(element, data) {
    if (Object.keys(data).length === 0) return;
    var ul = document.createElement('ul');
    for(var key in data){
        var li = document.createElement('li');
        li.textContent = key;
        createTree(li, data[key]);
        ul.append(li);
    }
    element.append(ul);
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.36163d1f.js.map
